<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" v-loading="loading" :model="formData" ref="formData" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item label="入库时间" prop="inboundTime">
              {{ formatDate(formData.inboundTime, 'YYYY-MM-DD HH:mm:ss') }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品名称" prop="productName">
              {{ formData.productName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品规格" prop="productSpecName">
              {{ formData.productSpecName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产日期或批号" prop="productionDateOrBatch">
              {{ formData.productionDateOrBatch || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保质期" prop="shelfLife">
              {{ formData.shelfLife || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入库数量" prop="inboundQuantity">
              {{ formData.inboundQuantity === '' || formData.inboundQuantity == null ? '--' : formData.inboundQuantity }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="交货人" prop="deliveryUserName">
              {{ formData.deliveryUserName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收货人" prop="receiveUserName">
              {{ formData.receiveUserName || '--' }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button v-if="loadFailed" @click="loadDetails" class="global-button">重新加载</el-button>
          <el-button @click="$router.back()" class="global-button">返回</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'FinishedGoodsInboundDetail',
  data() {
    return {
      loading: false,
      loadFailed: false,
      formData: {
        inboundId: '', // 成品入库ID
        inboundTime: '', // 入库时间
        productName: '', // 产品名称
        productSpecName: '', // 产品规格
        productionDateOrBatch: '', // 生产日期或批号
        shelfLife: '', // 保质期
        inboundQuantity: '', // 入库数量
        deliveryUserName: '', // 交货人
        receiveUserName: '' // 收货人
      }
    }
  },
  computed: {
    inboundId() {
      return this.$route.query.inboundId
    }
  },
  created() {
    this.loadDetails()
  },
  methods: {
    formatDate(value, format = 'YYYY-MM-DD') {
      return value ? dayjs(value).format(format) : '--'
    },
    loadDetails() {
      if (!this.inboundId) {
        this.$message.warning('缺少记录ID')
        return
      }
      this.loading = true
      this.loadFailed = false
      return this.$axios.get(this.$apis.prodManage.selectScFinishedGoodsInboundById, {
        params: { inboundId: this.inboundId }
      }).then(res => {
        this.formData = res
      }).catch(() => {
        this.loadFailed = true
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.form {
  word-break: break-all;
}
</style>
